import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col-12 col-lg-8"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "uq-preloader" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "loader loader--3" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "home py-56"
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "professionals-actions" }
const _hoisted_8 = { class: "h4 title text-primary mb-32" }
const _hoisted_9 = { class: "form mb-48" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "col" }
const _hoisted_18 = { class: "col" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col" }
const _hoisted_21 = { class: "col" }
const _hoisted_22 = { class: "col" }
const _hoisted_23 = { class: "form-group mb-24" }
const _hoisted_24 = { class: "form-label" }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col" }
const _hoisted_28 = { class: "col" }
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col" }
const _hoisted_32 = { class: "col" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = {
  key: 1,
  class: "d-flex table-responsive"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_form_group_input_text = _resolveComponent("v-form-group-input-text")!
  const _component_v_input_date = _resolveComponent("v-input-date")!
  const _component_v_table_header = _resolveComponent("v-table-header")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_ctx.isLoading === true)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_ctx.currentProfessional !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.$t('Mi perfil')), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("fieldset", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_v_form_group_input_text, {
                          value: _ctx.identityDocType,
                          label: _ctx.$t('Tipo documento'),
                          class: "mb-24",
                          autocomplete: "off",
                          disabled: true
                        }, null, 8, ["value", "label"])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_v_form_group_input_text, {
                          value: _ctx.currentProfessional?.nif,
                          label: _ctx.$t('Nº documento'),
                          class: "mb-24",
                          autocomplete: "off",
                          disabled: true
                        }, null, 8, ["value", "label"])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_v_form_group_input_text, {
                          value: _ctx.authUser.role.name ?? '',
                          label: _ctx.$t('Tipo de profesional'),
                          class: "mb-24",
                          autocomplete: "off",
                          disabled: true
                        }, null, 8, ["value", "label"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_v_form_group_input_text, {
                          value: _ctx.currentProfessional?.name,
                          label: _ctx.$t('Nombre'),
                          class: "mb-24",
                          autocomplete: "off",
                          disabled: true
                        }, null, 8, ["value", "label"])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_v_form_group_input_text, {
                          value: _ctx.currentProfessional?.surname,
                          label: _ctx.$t('Apellidos'),
                          class: "mb-24",
                          autocomplete: "off",
                          disabled: true
                        }, null, 8, ["value", "label"])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_v_form_group_input_text, {
                          type: "text",
                          value: _ctx.genre(),
                          label: _ctx.$t('Género'),
                          class: "mb-24",
                          autocomplete: "off",
                          disabled: true
                        }, null, 8, ["value", "label"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_v_form_group_input_text, {
                          type: "email",
                          value: _ctx.currentProfessional?.user.email,
                          label: _ctx.$t('Correo'),
                          class: "mb-24",
                          autocomplete: "off",
                          disabled: true
                        }, null, 8, ["value", "label"])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_v_form_group_input_text, {
                          value: _ctx.currentProfessional?.phoneNumber,
                          label: _ctx.$t('Teléfono'),
                          class: "mb-24",
                          autocomplete: "off",
                          disabled: true
                        }, null, 8, ["value", "label"])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('Fecha de nacimiento')), 1),
                          _createVNode(_component_v_input_date, {
                            value: _ctx.currentProfessional?.bornDate,
                            disabled: true
                          }, null, 8, ["value"])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("fieldset", _hoisted_25, [
                    _createElementVNode("legend", null, _toDisplayString(_ctx.$t('Especialidad')), 1),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_v_form_group_input_text, {
                          type: "email",
                          value: _ctx.currentProfessional?.speciality,
                          label: _ctx.$t('Principal'),
                          class: "mb-24",
                          autocomplete: "off",
                          disabled: true
                        }, null, 8, ["value", "label"])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_v_form_group_input_text, {
                          value: _ctx.currentProfessional?.subspeciality,
                          label: _ctx.$t('Subespecialidad'),
                          class: "mb-24",
                          autocomplete: "off",
                          disabled: true
                        }, null, 8, ["value", "label"])
                      ])
                    ])
                  ]),
                  _createElementVNode("fieldset", _hoisted_29, [
                    _createElementVNode("legend", null, _toDisplayString(_ctx.$t('Colegiado')), 1),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_v_form_group_input_text, {
                          value: _ctx.currentProfessional?.college,
                          label: _ctx.$t('Colegio'),
                          class: "mb-24",
                          autocomplete: "off",
                          disabled: true
                        }, null, 8, ["value", "label"])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_v_form_group_input_text, {
                          value: _ctx.currentProfessional?.collegeNumber,
                          label: _ctx.$t('Número de colegiado'),
                          class: "mb-24",
                          autocomplete: "off",
                          disabled: true
                        }, null, 8, ["value", "label"])
                      ])
                    ])
                  ]),
                  _createElementVNode("fieldset", _hoisted_33, [
                    _createElementVNode("legend", null, _toDisplayString(_ctx.$t('Clínicas de trabajo')), 1),
                    _createElementVNode("div", _hoisted_34, [
                      (this.currentProfessional.clinics.length === 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.$t('No tienes clínicas asociadas a tu perfil profesional. Puedes pedírselo a tu administrador.')), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                            _createVNode(_component_v_table, { class: "table" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_table_header, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('Nombre')), 1),
                                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('Dirección')), 1),
                                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('Teléfono')), 1)
                                    ]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.currentProfessional.clinics, (clinic) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        key: clinic.id
                                      }, [
                                        _createElementVNode("td", null, _toDisplayString(clinic.name), 1),
                                        _createElementVNode("td", null, _toDisplayString(clinic.address), 1),
                                        _createElementVNode("td", null, _toDisplayString(clinic.phoneNumber), 1)
                                      ]))
                                    }), 128))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
}